import actions from "./actions";

const reducers = {
  [actions.downloadDeleteTemplate.request]: (state, action) => {
    state.loading = true;
  },
  [actions.downloadDeleteTemplate.success]: (state, action) => {
    state.loading = false;
  },
  [actions.downloadDeleteTemplate.failure]: (state, action) => {
    state.loading = false;
  },
};

export default reducers;
